/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown> }} Event_State_Start_Time_MInputs */

const en_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Starts in ${i?.min}m`)
};

const ar_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يبدأ بعد ${i?.min} د`)
};

const de_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Startet in ${i?.min}m`)
};

const es_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Comienza en ${i?.min}m`)
};

const fr_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Commence dans ${i?.min}m`)
};

const it_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inizia tra ${i?.min}m`)
};

const ja_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}分後に開始`)
};

const ko_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}분 후 시작`)
};

const pt_br_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Começa em ${i?.min}m`)
};

const ru_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Начнется через ${i?.min}м`)
};

const th_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เริ่มในอีก ${i?.min} นาที`)
};

const tr_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} dk sonra başlıyor`)
};

const zh_cn_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} 分钟后开始`)
};

const zh_tw_event_state_start_time_m = /** @type {(inputs: Event_State_Start_Time_MInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} 分鐘後開始`)
};

/**
* | output |
* | --- |
* | "Starts in {min}m" |
*
* @param {Event_State_Start_Time_MInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_state_start_time_m = /** @type {((inputs: Event_State_Start_Time_MInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_State_Start_Time_MInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_state_start_time_m(inputs)
	if (locale === "ar") return ar_event_state_start_time_m(inputs)
	if (locale === "de") return de_event_state_start_time_m(inputs)
	if (locale === "es") return es_event_state_start_time_m(inputs)
	if (locale === "fr") return fr_event_state_start_time_m(inputs)
	if (locale === "it") return it_event_state_start_time_m(inputs)
	if (locale === "ja") return ja_event_state_start_time_m(inputs)
	if (locale === "ko") return ko_event_state_start_time_m(inputs)
	if (locale === "pt_br") return pt_br_event_state_start_time_m(inputs)
	if (locale === "ru") return ru_event_state_start_time_m(inputs)
	if (locale === "th") return th_event_state_start_time_m(inputs)
	if (locale === "tr") return tr_event_state_start_time_m(inputs)
	if (locale === "zh_cn") return zh_cn_event_state_start_time_m(inputs)
	return zh_tw_event_state_start_time_m(inputs)
});